import {
  invoiceGrid,
  invoiceItemGrid,
  postInvoiceTypes,
  dropDown,
  targetInvoiceTypes,
  updateInvoiceTypes,
} from './interfaces'
import { DateFormatter, ErrorLogger } from '../data/helper'
import axios from 'axios'

const apiURL = process.env.REACT_APP_API_URL

const dateFormatter = new DateFormatter()

//#region getInvoice
export const getInvoices = async (month: number | null): Promise<invoiceGrid[]> => {
  const token = localStorage.getItem('authToken')

  if (!token) {
    throw new Error('Authorization token not found')
  }

  var url = `https://${apiURL}/Invoice`;
  if (month != null && month > 0) {
    url = url + `?month=${month}`;
  }

  const response = await axios.get<invoiceGrid[]>(
    url,
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + token,
      },
    }
  )

  const invoiceData: invoiceGrid[] = response.data.map((item) => ({
    noteCount: item.noteCount,
    invoiceId: item.invoiceId,
    ref: item.ref,
    refFormatted: item.refFormatted,
    orderNo: item.orderNo,
    client: item.client,
    site: item.site,
    createdDate: item.createdDate,
    value: item.value,
    createdBy: item.createdBy,
    invoiceDate: item.invoiceDate,
    emailedDate: item.emailedDate ?? null,
  }))
  return invoiceData
}
//#endregion

//#region getInvoiceItems
export const getInvoiceItems = async (invoiceId: number): Promise<invoiceItemGrid[]> => {
  const token = localStorage.getItem('authToken')

  if (!token) {
    throw new Error('Authorization token not found')
  }

  const response = await axios.get<invoiceItemGrid[]>(
    `https://${apiURL}/Invoice/Items/${invoiceId}`,
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + token,
      },
    }
  )

  const invoiceData: invoiceItemGrid[] = response.data.map((item) => ({
    invoiceitemId: item.invoiceitemId,
    invoiceRef: item.invoiceRef,
    jobId: item.jobId,
    jobRefFormatted: item.jobRefFormatted,
    departmentId: item.departmentId,
    department: item.department,
    description: item.description,
    orderNo: item.orderNo,
    itemDate: item.itemDate,
    itemValue: item.itemValue,
    vatAmount: item.vatAmount,
    vatPercent: item.vatPercent,
    vatValue: item.vatValue,
    nominalCode: item.nominalCode
  }))
  
  return invoiceData
}
//#endregion

//#region submitInvoice
export const submitInvoice = async (invoice: postInvoiceTypes) => {
  const token = localStorage.getItem('authToken')

  if (!token) {
    throw new Error('Authorization token not found')
  }

  console.log("invoice", invoice);
  console.log("invoice", invoice.contactId);

  try {
    const response = await axios({
      url: `https://${apiURL}/Invoice`,
      method: 'post',
      data: {
        careOfTitle: invoice.careOfTitle,
        contactId: invoice.contactId,
        orderNo: invoice.orderNo,
        clientId: invoice.clientId,
        siteId: invoice.siteId,
        invoiceDate: invoice.invoiceDate,
        paymentTermId: invoice.paymentTermId,
        documentTypeId: invoice.documentTypeId,
      },
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + token,
      },
    })

    const data: postInvoiceTypes = response.data

    const invoiceId = data.invoiceId

    if (invoiceId) {
      //addInvoiceToSage(invoiceId);
    } else {
      throw new Error('Job ID not found in response');
    }

    return data
  } catch (error) {
    console.log(error)
  }
}
//#endregion

//#region addInvoiceToSage
/*
export const addInvoiceToSage = async (invoiceId: number) => {
  const token = localStorage.getItem('authToken')

  if (!token) {
    throw new Error('Authorization token not found')
  }

  const response = await axios({
    
    url: `https://${apiURL}/Invoice/AddToSage/${invoiceId}`,
    method: 'post',
    
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    },
  })

  const data = response.data

  return data;
}
  */
//#endregion

//#region updateInvoice
export const updateInvoice = async (invoice: updateInvoiceTypes, invoiceId: number) => {
  const token = localStorage.getItem('authToken')

  if (!token) {
    throw new Error('Authorization token not found')
  }
  console.log("invoice", invoice);
  const response = await axios({
    url: `https://${apiURL}/Invoice/${invoiceId}`,
    method: 'put',
    data: {
      careOfTitle: invoice.careOfTitle,
      contactId: invoice.contact,
      invoiceId: invoiceId,
      orderNo: invoice.orderNo,
      clientId: invoice.clientId,
      siteId: invoice.siteId,
      invoiceDate: invoice.invoiceDate,
      paymentTermId: invoice.paymentTermId,
    },
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    },
  }).then((resp) => {
    const data: updateInvoiceTypes = resp.data
    
    return data;
    
  }).catch((err) => { 
    ErrorLogger.Log(err);
  });
}
//#endregion

//#region updateInvoiceToSage
/*
export const updateInvoiceToSage = async (invoiceId: number) => {
  const token = localStorage.getItem('authToken')

  if (!token) {
    throw new Error('Authorization token not found')
  }

  const response = await axios({
    
    url: `https://${apiURL}/Invoice/UpdateToSage/${invoiceId}`,
    method: 'post',
    
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    },
  })

  const data = response.data

  return data;
}
  */
//#endregion

//#region deleteInvoice
export const deleteInvoice = async (invoiceId: number) => {
  const token = localStorage.getItem('authToken')

  if (!token) {
    throw new Error('Authorization token not found')
  }

  const response = await axios({
    url: `https://${apiURL}/Invoice/${invoiceId}`,
    method: 'delete',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    },
  })

  const data = response.data

  return data
}
//#endregion

//#region getTargetInvoice
export const getTargetInvoice = async (invoiceId: number): Promise<targetInvoiceTypes> => {
  const token = localStorage.getItem('authToken')

  if (!token) {
    throw new Error('Authorization token not found')
  }


  const response = await axios.get(`https://${apiURL}/Invoice/${invoiceId}`, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    },
  })

  console.log("resresres", response.data);

  const data: targetInvoiceTypes = response.data

  const targetInvoiceData: targetInvoiceTypes = {
    careOfTitle: data.careOfTitle,
    contact: {
      contactId: data.contact?.contactId,
    },
    invoiceId: data.invoiceId,
    ref: data.ref,
    refFormatted: data.refFormatted,
    orderNo: data.orderNo,
    clientId: data.clientId,
    client: data.client,
    siteId: data.siteId,
    site: data.site,
    paymentTermId: data.paymentTermId,
    paymentTerm: data.paymentTerm,
    invoiceDate: data.invoiceDate,
    invoiceType: data.invoiceType,
    value: data.value,
  }

  return targetInvoiceData
}
//#endregion

//#region exportInvoice
export const exportInvoice = async (invoiceId: number, ref: string) => {
  const token = localStorage.getItem('authToken')

  if (!token) {
    throw new Error('Authorization token not found')
  }

  const response = await axios.get(
    `https://${apiURL}/PDF/Invoice/${invoiceId}`,
    {
      responseType: 'blob',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + token,
      },
    }
  )

  const url = window.URL.createObjectURL(new Blob([response.data]))
  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', 'invoice-' + ref + '.pdf')
  document.body.appendChild(link)
  link.click()
}
//#endregion
export interface NewInvoiceLine {
  jobId: number | null
  description: string
  orderNo: string | null
  itemValue: number
  xeroDepartmentId: number | null
  xeroTaxRateId: number | null
}

export interface NewInvoiceWithItems {
  careOfTitle: string | null
  contactId: number
  orderNo: string | null
  clientId: number
  siteId: number
  invoiceDate: Date
  paymentTermId: number
  documentTypeId: number
  /** The email template the invoice is emailed with. */
  emailTemplateId: number
  items: NewInvoiceLine[]
}

/**
 * Creates an invoice and all its lines in one request, the way Xero does. The
 * API saves them together and sends the finished invoice to Xero once;
 * xeroError is set when the invoice saved but Xero didn't accept it.
 */
export const submitInvoiceWithItems = async (
  invoice: NewInvoiceWithItems
): Promise<{ invoice: any; xeroError: string | null }> => {
  const token = localStorage.getItem('authToken')

  if (!token) {
    throw new Error('Authorization token not found')
  }

  const response = await axios.post(`https://${apiURL}/Invoice/WithItems`, invoice, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    },
  })

  return response.data
}

/** A saved line, with everything the invoice page needs to edit it. */
export interface InvoiceLine {
  invoiceitemId: number
  jobId: number | null
  jobRefFormatted: string | null
  description: string | null
  orderNo: string | null
  itemValue: number
  xeroDepartmentId: number | null
  xeroTaxRateId: number | null
}

export const getInvoiceLines = async (invoiceId: number): Promise<InvoiceLine[]> => {
  const token = localStorage.getItem('authToken')

  if (!token) {
    throw new Error('Authorization token not found')
  }

  const response = await axios.get(`https://${apiURL}/Invoice/Items/${invoiceId}`, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    },
  })

  return response.data.map((item: any) => ({
    invoiceitemId: item.invoiceitemId,
    jobId: item.jobId ?? null,
    jobRefFormatted: item.jobId ? item.jobRefFormatted : null,
    description: item.description ?? null,
    orderNo: item.orderNo ?? null,
    itemValue: item.itemValue ?? 0,
    xeroDepartmentId: item.xeroDepartmentId ?? null,
    xeroTaxRateId: item.xeroTaxRateId ?? null,
  }))
}

/**
 * Saves an invoice's details and its complete set of lines together: lines
 * with an invoiceitemId are updated, new ones added, and any left out removed.
 */
export const updateInvoiceWithItems = async (
  invoiceId: number,
  invoice: NewInvoiceWithItems & { items: (NewInvoiceLine & { invoiceitemId: number | null })[] }
): Promise<{ invoice: any; xeroError: string | null }> => {
  const token = localStorage.getItem('authToken')

  if (!token) {
    throw new Error('Authorization token not found')
  }

  const response = await axios.put(
    `https://${apiURL}/Invoice/${invoiceId}/WithItems`,
    { ...invoice, invoiceId },
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + token,
      },
    }
  )

  return response.data
}

/** An invoice's details as the API sends them, for the invoice page. */
export interface InvoiceDetails {
  invoiceId: number
  ref: number
  refFormatted: string
  orderNo: string | null
  clientId: number
  client: string
  siteId: number
  site: string
  contactId: number
  careOfTitle: string | null
  paymentTermId: number
  documentTypeId: number
  invoiceDate: string | null
  xeroId: string | null
  /** When it was last emailed to its contact, if ever. */
  emailedDate: string | null
  emailedTo: string | null
  emailedBy: string | null
  emailTemplateId: number | null
  emailTemplate: string | null
}

export const getInvoiceDetails = async (invoiceId: number): Promise<InvoiceDetails> => {
  const token = localStorage.getItem('authToken')

  if (!token) {
    throw new Error('Authorization token not found')
  }

  const response = await axios.get(`https://${apiURL}/Invoice/${invoiceId}`, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    },
  })

  return response.data
}

//#region Email invoice
/** What emailing an invoice will send, for the user to confirm first. */
export interface InvoiceEmailPreview {
  /** The contact's address; null when they have none and it can't be sent. */
  to: string | null
  contactName: string | null
  /** The email template chosen on the invoice. */
  templateName: string | null
  /** Why it can't be sent, other than a missing address. */
  problem: string | null
  subject: string
  body: string
  attachmentName: string
  emailedDate: string | null
  emailedTo: string | null
}

export interface InvoiceEmailResult {
  emailedDate: string
  emailedTo: string
  emailedBy: string | null
}

/** An email template to choose on an invoice. */
export interface EmailTemplateOption {
  emailTemplateId: number
  name: string
  isDefault: boolean
  /** Retired, but still the one on this invoice. */
  isRetired: boolean
}

/**
 * The email templates to choose from, the default first. Pass the invoice's
 * current template so it is listed even if it has since been retired.
 */
export const getEmailTemplateOptions = async (currentId?: number | null): Promise<EmailTemplateOption[]> => {
  const token = localStorage.getItem('authToken')

  if (!token) {
    throw new Error('Authorization token not found')
  }

  const response = await axios.get(`https://${apiURL}/Invoice/EmailTemplates`, {
    params: currentId ? { currentId } : undefined,
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    },
  })

  return response.data
}

export const getInvoiceEmailPreview = async (invoiceId: number): Promise<InvoiceEmailPreview> => {
  const token = localStorage.getItem('authToken')

  if (!token) {
    throw new Error('Authorization token not found')
  }

  const response = await axios.get(`https://${apiURL}/Invoice/${invoiceId}/Email`, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    },
  })

  return response.data
}

/**
 * Emails the invoice. The subject and message are sent as edited in the send
 * dialog; leaving either out uses the invoice's template.
 */
export const emailInvoice = async (
  invoiceId: number,
  content?: { subject: string; body: string }
): Promise<InvoiceEmailResult> => {
  const token = localStorage.getItem('authToken')

  if (!token) {
    throw new Error('Authorization token not found')
  }

  const response = await axios.post(`https://${apiURL}/Invoice/${invoiceId}/Email`, content ?? null, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    },
  })

  return response.data
}
//#endregion
